<template>
  <b-modal
    :id="'modalPayment' + (isAds?'Ads':'')"
    :ref="'modalPayment' + (isAds?'Ads':'')"
    static
    lazy
    size="lg"
    class="modalPayment"
    @hide="modalHideHandler()">
    <div
      slot="modal-header"
      :header-border-variant="0"
      class="modalPaymentHeader">
      <svgicon
        name="back"
        width="18"
        height="12"
        class="icon-back"
        @click="hideModal"/>
      <div>{{ title }}</div>
      <div
        v-if="user"
        class="balance">
        <span>Баланс:</span>
        {{ user.balance ? user.balance : 0 }}
        руб.
      </div>
    </div>
    <div class="content">
      <div
        v-if="productTitle"
        class="items">
        <div class="item">
          <div class="item-title">
            <span>Товар:</span>
            <div>
              <strong>
                {{ productTitle }}
              </strong>
            </div>
          </div>
          <div
            v-if="count"
            class="item-count">
            <span>Кол-во:</span>
            <div>
              {{ count }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="showPriceChanger">
        <b-form-group
          class="price-changer-wrapper"
          label="Сумма пополнения:"
          label-for="price-changer">
          <b-input
            id="price-changer"
            v-model="priceChanger"
            min="1"
            type="number"
            placeholder="100"/>
        </b-form-group>
      </div>
      <div class="payment-items">
        <span>Выберите способ оплаты: </span>
        <div
          v-if="showLoadMethodsSpinner"
          class="d-flex justify-content-center mb-3">
          <b-spinner
            variant="primary"
            type="grow"
            label="Spinning"/>
        </div>
        <template v-else>
          <span v-if="user && isBalanceUsed && parseFloat(user.balance) < parseFloat(price)">
            <span class="warring">Не хватает средств</span>
            Вы можете доплатить <b>{{ parseFloat(parseFloat(price) - parseFloat(user.balance)).toFixed(2) }} рублей</b> любым
            из предложенных способов:
          </span>
          <div
            v-if="user && parseFloat(user.balance) && parseFloat(user.balance) != 0"
            class="payment-item">
            <div
              class="payment-item-content"
              :class="{ selected: isBalanceUsed }"
              @click="useBalance()">
              <div>
                Баланс
                <strong>{{ user.balance ? user.balance : 0 }}</strong>
              </div>
            </div>
          </div>
          <img
            v-if="isBalanceUsed && parseFloat(user.balance) < parseFloat(price)"
            class="plus-icon"
            src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNSAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgNy41SDE1TTcuNSAwVjE1IiBzdHJva2U9IiMwOThBRkYiLz4KPC9zdmc+Cg==">
          <div
            v-for="(paymentType, index) in paymentTypeList"
            :key="index"
            class="payment-item"
            :class="paymentType.enabled == true ? '' : 'd-none'">
            <div
              class="payment-item-content"
              :class="{
                selected: !!(
                  selectedPaymentMethod && selectedPaymentMethod.key == index
                )
              }"
              @click="selectPaymentMethod(index)">
              <div>
                <img
                  v-if="paymentType.icon"
                  :src="'data:image/svg+xml;base64,' + paymentType.icon">
                {{ paymentType.name }}
              </div>
            </div>
          </div>
          <template v-if="user && isBalanceUsed && selectedPaymentMethod">
            <span class="well">
              Мы спишем <strong>{{ user.balance }} рублей</strong> с Вашего
              баланса и <strong>{{ parseFloat(parseFloat(price) - parseFloat(user.balance)).toFixed(2) }} рублей</strong> с
              <strong>{{ selectedPaymentMethod.title }}</strong>
              <b-button
                variant="link"
                @click="resetPayment()">
                <b>Оплатить по-другому</b>
              </b-button>
            </span>
          </template>
        </template>
      </div>
      <b-row v-if="showPhoneInput">
        <b-col cols="6">
          <b-form>
            <b-form-group
              id="input-group-payment-phone"
              label="Введите номер телефона:"
              label-for="payment-phone">
              <b-input
                id="payment-phone"
                v-model="walletPhone"
                placeholder="379158875638"
                @input="phoneHandler"/>
              <b-form-text>
                Номер в междрународном формате. Без "+"
              </b-form-text>
              <b-form-invalid-feedback :state="phoneValidation">
                Введите номер в международном фомате: 379158875638
              </b-form-invalid-feedback>
            </b-form-group>
          </b-form>
        </b-col>
      </b-row>
    </div>
    <div
      slot="modal-footer"
      class="modalPaymentFooter">
      <div
        v-if="user && (!isBalanceUsed || (isBalanceUsed && parseFloat(user.balance) < parseFloat(price)))"
        class="total-price">
        <span>
          Нужно оплатить
        </span>
        <template v-if="isBalanceUsed">
          {{ parseFloat(user.balance) >= parseFloat(price) ? 0 : parseFloat(price) - parseFloat(user.balance) }} руб.
        </template>
        <template v-else>
          {{ price }} руб.
        </template>
      </div>
      <div
        v-if="user && (!isBalanceUsed || (isBalanceUsed && parseFloat(user.balance) < parseFloat(price)))"
        class="total-commission">
        <span>
          Комиссия
          <template v-if="selectedPaymentMethod">
            <img
              v-if="selectedPaymentMethod.icon"
              :src="'data:image/svg+xml;base64,' + selectedPaymentMethod.icon">
            <strong v-else>
              {{ selectedPaymentMethod.name }}
            </strong>
          </template>
        </span>
        <b-spinner
          v-if="showFeeSpinner"
          variant="primary"
          type="grow"
          label="Loading"/>
        <template v-if="false">
          {{ selectedPaymentMethod != null ? selectedPaymentMethod.fee : 0 }}
          руб.
        </template>
      </div>
      <div
        v-if="false && user && (!isBalanceUsed || (isBalanceUsed && parseFloat(user.balance) < parseFloat(price)))"
        class="total-payment">
        <span>К оплате:</span>
        {{ toPay }}
        руб.
      </div>
      <div
        v-if="user && (isBalanceUsed && parseFloat(user.balance) >= parseFloat(price))"
        class="total-price">
        <span>Итого:</span>
        {{ price }}
        руб.
      </div>
      <button
        v-if="isShowPayButton"
        class="btn btn-success"
        :disabled="paymentButtonDisabled"
        @click="payment">
        <b-spinner
          v-if="showBuySpinner"
          variant="primary"
          :disabled="showBuySpinner"
          small/>
        {{ payButtonText }}
      </button>
    </div>
  </b-modal>
</template>

<script>
import "~/icons/close";
import "~/icons/back";
import "~/icons/ok";
import "~/icons/payment_plus-icon";
import "~/icons/payment_visa-icon";
import axios from "axios";
import { mapState } from "vuex";
import { errorResponse } from '~/services/errors-template';

let timeoutId;

export default {
  components: {
    //ratingStars
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    productTitle: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "Покупка товара"
    },
    payButtonText: {
      type: String,
      default: "Оплатить"
    },
    count: {
      type: Number,
      default: 1
    },
    offerPrice: {
      type: Number,
      default: 0
    },
    showPriceChanger: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: Number,
      default: null
    },
    modalClose: {
      type: Function,
      default: () => {}
    },
    paymentSuccess: {
      type: Function,
      default: () => {}
    },
    isAds:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showLoadMethodsSpinner: false,
      showFeeSpinner: false,
      showBuySpinner: false,
      paymentButtonDisabled: false,
      selectedPaymentMethod: null,
      promo: false,
      isBalanceUsed: false,
      priceChanger: 1,
      paymentTypeList: [
        {
          type: "card",
          title: "VISA",
          icon:
            "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",
          name: "",
          alias: "card",
          fee: 0,
          fee_percent: 0.06,
          enabled: true,
          link: null
        },
        {
          type: "card",
          title: "Mastercard",
          icon:
            "PHN2ZyB3aWR0aD0iMzciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAzNyAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIzLjc2MDYgMy4yODQxOEgxMy45NDc5VjIxLjQzOTZIMjMuNzYwNlYzLjI4NDE4WiIgZmlsbD0iI0ZGNUYwMCIvPgo8cGF0aCBkPSJNMTQuNTcwOSAxMi4zNjQ1QzE0LjU2OTEgMTAuNjE1OCAxNC45NTM4IDguODg5NTYgMTUuNjk1OSA3LjMxNjU0QzE2LjQzOCA1Ljc0MzUyIDE3LjUxODEgNC4zNjQ5NiAxOC44NTQzIDMuMjg1MjVDMTcuMTk5OCAxLjk0NjY4IDE1LjIxMyAxLjExNDMgMTMuMTIwOCAwLjg4MzI0N0MxMS4wMjg2IDAuNjUyMTk1IDguOTE1NTMgMS4wMzE3OSA3LjAyMjk5IDEuOTc4NjVDNS4xMzA0NSAyLjkyNTUyIDMuNTM0ODMgNC40MDE0NCAyLjQxODUxIDYuMjM3NzVDMS4zMDIxOSA4LjA3NDA1IDAuNzEwMjA1IDEwLjE5NjYgMC43MTAyMDUgMTIuMzYyOUMwLjcxMDIwNSAxNC41MjkyIDEuMzAyMTkgMTYuNjUxOCAyLjQxODUxIDE4LjQ4ODFDMy41MzQ4MyAyMC4zMjQ0IDUuMTMwNDUgMjEuODAwNCA3LjAyMjk5IDIyLjc0NzJDOC45MTU1MyAyMy42OTQxIDExLjAyODYgMjQuMDczNyAxMy4xMjA4IDIzLjg0MjZDMTUuMjEzIDIzLjYxMTYgMTcuMTk5OCAyMi43NzkyIDE4Ljg1NDMgMjEuNDQwNkMxNy41MTg1IDIwLjM2MTMgMTYuNDM4NyAxOC45ODMyIDE1LjY5NjYgMTcuNDEwOEMxNC45NTQ1IDE1LjgzODQgMTQuNTY5NiAxNC4xMTI3IDE0LjU3MDkgMTIuMzY0NVoiIGZpbGw9IiNFQjAwMUIiLz4KPHBhdGggZD0iTTM3IDEyLjM2MzlDMzYuOTk5OSAxNC41MzA0IDM2LjQwNzggMTYuNjUzMSAzNS4yOTEzIDE4LjQ4OTVDMzQuMTc0NyAyMC4zMjU5IDMyLjU3ODkgMjEuODAxOCAzMC42ODYxIDIyLjc0ODVDMjguNzkzMyAyMy42OTUyIDI2LjY4IDI0LjA3NDYgMjQuNTg3NyAyMy44NDMyQzIyLjQ5NTQgMjMuNjExOCAyMC41MDg1IDIyLjc3OSAxOC44NTQyIDIxLjQ0QzIwLjE4OTUgMjAuMzU5NyAyMS4yNjkgMTguOTgxMyAyMi4wMTEyIDE3LjQwODhDMjIuNzUzNSAxNS44MzYyIDIzLjEzOTIgMTQuMTEwNyAyMy4xMzkyIDEyLjM2MjNDMjMuMTM5MiAxMC42MTQgMjIuNzUzNSA4Ljg4ODQyIDIyLjAxMTIgNy4zMTU5MUMyMS4yNjkgNS43NDMzOSAyMC4xODk1IDQuMzY0OTcgMTguODU0MiAzLjI4NDYzQzIwLjUwODUgMS45NDU2NCAyMi40OTU0IDEuMTEyODYgMjQuNTg3NyAwLjg4MTQ3NEMyNi42OCAwLjY1MDA5IDI4Ljc5MzMgMS4wMjk0NCAzMC42ODYxIDEuOTc2MTdDMzIuNTc4OSAyLjkyMjkgMzQuMTc0NyA0LjM5ODggMzUuMjkxMyA2LjIzNTE3QzM2LjQwNzggOC4wNzE1MyAzNi45OTk5IDEwLjE5NDMgMzcgMTIuMzYwN1YxMi4zNjM5WiIgZmlsbD0iI0Y3OUUxQiIvPgo8L3N2Zz4K",
          name: "",
          alias: "card",
          fee: 0,
          fee_percent: 0.06,
          enabled: true,
          link: null
        },
        {
          type: "card",
          title: "МИР",
          icon:
            "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",
          name: "",
          alias: "card",
          fee: 0,
          fee_percent: 0.06,
          enabled: true,
          link: null
        },
       /* {
          type: "card",
          title: "ApplePay",
          icon: null,
          name: "ApplePay",
          alias: "applepay",
          fee: 0,
          fee_percent: 0.04,
          enabled: true,
          link: null
        },*/
        {
          type: "yandexmoney",
          title: "ЮMoney",
          icon: null,
          name: "ЮMoney",
          alias: "yandex",
          fee: 0,
          fee_percent: 0.06,
          enabled: true,
          link: null
        },
        /*{
          type: "webmoney",
          title: "Webmoney WMR",
          icon: "",
          name: "WMR",
          alias: "webmoneyWmr",
          fee: 0,
          fee_percent: 0.05,
          enabled: true,
          link: null
        },*/
        {
          type: "qiwi",
          title: "Qiwi Кошелек",
          icon:
            "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",
          name: "",
          alias: "qiwi",
          fee: 0,
          fee_percent: 0.075,
          enabled: true,
          link: null
        },
        {
          type: "usdt",
          title: "USDT TRC-20",
          icon: null,
          name: "USDT TRC-20",
          alias: "usdt_trc20",
          fee: 0,
          fee_percent: 0,
          enabled: true,
          link: null
        },
        {
          type: "usdt",
          title: "USDT ERC-20",
          icon: null,
          name: "USDT ERC-20",
          alias: "usdt_erc20",
          fee: 0,
          fee_percent: 0,
          enabled: true,
          link: null
        },
        /*{
          type: "mobile",
          title: "Beeline",
          icon: null,
          name: "Beeline",
          alias: "mc",
          fee: 0,
          fee_percent: 0.2,
          enabled: true,
          link: null
        },
        {
          type: "mobile",
          title: "Tele2",
          icon:
            "PHN2ZyB3aWR0aD0iNDYiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCA0NiAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuNjQ3OTQ5IDYuNjAxNzZWOS4wMTU1Nkw3LjIxMDUzIDguMjk5MjlWNS42ODY3MkwwLjY0Nzk0OSA2LjYwMTc2Wk0yLjc0MjE4IDkuMTYyMzlWMTcuNDMzOEg1LjE0NDgxVjguOTE4NzVMMi43NDIxOCA5LjE2MjM5Wk04LjA5Njg0IDUuNTYzMTZWMTcuNDMzOEgxMC42Mjg1VjUuMjA5OThMOC4wOTY4NCA1LjU2MzE2Wk0xMS4xMDAyIDUuMTQ0MTVWNy44NzQ4OEwxNC43NTYgNy40NzU3OVY0LjYzNDQ5TDExLjEwMDIgNS4xNDQxNVpNMTEuMTAwMiA5LjkwNzM0VjEyLjY4NzhMMTMuNSAxMi41NThWOS43MDIzOUwxMS4xMDAyIDkuOTA3MzRaTTExLjEwMDIgMTQuNjkyVjE3LjQzMzhIMTQuNzU2VjE0LjU4MjZMMTEuMTAwMiAxNC42OTJaTTI0LjIxMDIgMy4zMTE4OFYxNy40MzM4SDI3LjUyOTFWMi44NDkwMkwyNC4yMTAyIDMuMzExODhaTTI4LjE0ODggMi43NjI0OVY2LjAxMDg1TDMyLjk4NTQgNS40ODMxOVYyLjA4Nzg4TDI4LjE0ODggMi43NjI0OVpNMjguMTQ4OCA4LjQ1MzgzVjExLjc2MjRMMzEuMzE4OSAxMS41OTA2VjguMTg0NDhMMjguMTQ4OCA4LjQ1MzgzWk0yOC4xNDg4IDE0LjE4MDdWMTcuNDMzOEgzMi45ODU0VjE0LjAzNThMMjguMTQ4OCAxNC4xODA3Wk0xNS43MjMzIDQuNDk5MzZWMTcuNDMzOEgxOC42MDcxVjQuMDk3MDZMMTUuNzIzMyA0LjQ5OTM2Wk0xOS4xNDU0IDE0LjQ1MTJWMTcuNDMzNkgyMy4zMzE1VjE0LjMyNThMMTkuMTQ1NCAxNC40NTEyWk00My44Mjg5IDEuOTI4MTlDNDIuNzc5OSAwLjk0NDg3OCA0MS4yNDIgMC41NDE1NDkgMzkuNTU5OCAwLjc4MTMzNVY0LjM4NDE2QzQwLjI0MSA0LjM0NjYyIDQwLjc5MyA0LjU5NzQ2IDQxLjAzODkgNS4xMDI0OUM0MS40MjczIDUuODk4NzQgNDEuMDI2NiA3LjA5MzQyIDQwLjA4MTUgOC4yMDAyOUMzOC42MjI3IDkuOTA4MzYgMzQuNzQzNSAxMy40MDQ1IDM0Ljc0MzUgMTMuNDA0NUw0MC4zMTIzIDEzLjIyMjhDNDMuNzE0OCA5LjkyNDQ0IDQ0LjkzNjcgNy45MjIzMiA0NS4xNTYgNS40MjM1M0M0NS4yNzEyIDQuMTAxNTYgNDQuNzg3NiAyLjgyNzgxIDQzLjgyODkgMS45MjgxOVpNNDUuMzUyMiAxNy40MzM4VjEzLjY2MzlMMzQuMDU3MiAxNC4wMDE2TDQ1LjM1MjIgMTcuNDMzOFpNMzQuMDU3MiAxNC4wMDE0TDM0LjA1ODMgMTcuNDMzNkg0NS4zNTIyTDM0LjA1NzIgMTQuMDAxNFpNMzguOTEwNSAwLjg2MjIwN0MzNS42MjkyIDEuNTU1NTkgMzQuMDE3OSAzLjk1MDg4IDM0LjIwMzggNy44NTkzMkwzNy43MDI0IDcuNTUxMjZDMzcuNTQzMSA1LjM0MzE4IDM4LjIyMzcgNC44MTkzOCAzOC45MTIyIDQuNTMxMzhMMzguOTEwNSAwLjg2MjIwN1oiIGZpbGw9IiMxNDE0MTQiLz4KPC9zdmc+Cg==",
          name: "",
          alias: "mc",
          fee: 0,
          fee_percent: 0.2,
          enabled: true,
          link: null
        },
        {
          type: "mobile",
          title: "МТС",
          icon:
            "PHN2ZyB3aWR0aD0iNTIiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCA1MiAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjYyMjIgMEMzLjY1NzQzIDAgMi41MTM1NyAwLjkzMTY2OCAxLjU3MDA1IDIuNDk3OThDMC41ODY2NTcgNC4xMjAxNSAwIDYuMTI4MzUgMCA3Ljg3MjNDMCAxMC40MjUzIDEuNDI2MzYgMTMgNC42MjI0NyAxM0M3LjgxNDc0IDEzIDkuMjQ0OTQgMTAuNDI1MyA5LjI0NDk0IDcuODcyM0M5LjI0NDk0IDYuMTI4MzUgOC42NTg1NSA0LjEyMDE1IDcuNjc5OSAyLjQ5Nzk4QzYuNzI3NTQgMC45MzE2NjggNS41ODM4MSAwIDQuNjIyMiAwWk0yOS41ODIzIDMuODMwNDJIMzIuODE4MVYxMi4zMDM4SDM2LjI4NDlWMy44MzA0MkgzOS41MTkzVjAuNjk2MDY1SDI5LjU4MjNWMy44MzAwMlYzLjgzMDQyWk00Ni45MTUzIDMuODMwNDJINTJWMC42OTYwNjVINDYuOTE1M0M0Mi4yNDM5IDAuNjk2MDY1IDM5Ljc0OTEgMy4wMjkwMiAzOS43NDkxIDYuNDk5NTRDMzkuNzQ5MSA5Ljk3MDA1IDQyLjI0MzkgMTIuMzAzOCA0Ni45MTUzIDEyLjMwMzhINTJWOS4xNjk1OEg0Ni45MTUzQzQ0Ljc1MzMgOS4xNjk1OCA0My4zMzIyIDguMzkzMzkgNDMuMzMyMiA2LjQ5OTkzQzQzLjMzMjIgNC42MDY0OCA0NC43NTMzIDMuODMwNDIgNDYuOTE1MyAzLjgzMDQyWk0yMi41MzExIDAuNjk2MDY1TDIwLjY4MzQgNy42MjQyM0wxOC44MzU4IDAuNjk2MDY1SDEyLjcxMTdWMTIuMzAzOEgxNi4xNzcyVjIuODYyNEwxOC42OTU4IDEyLjMwMzhIMjIuNjcxMUwyNS4xOTEgMi44NTY3VjEyLjMwMzhIMjguNjU3OVYwLjY5NjA2NUgyMi41MzExWiIgZmlsbD0iI0UzMDYxMyIvPgo8L3N2Zz4K",
          name: "",
          alias: "mc",
          fee: 0,
          fee_percent: 0.2,
          enabled: true,
          link: null
        },
        {
          type: "mobile",
          title: "Мегафон",
          icon: null,
          name: "Мегафон",
          alias: "mc",
          fee: 0,
          fee_percent: 0.2,
          enabled: true,
          link: null
        }*/
      ],
      paymentForm: null,
      paymentFormSubmitScenario: true,
      showPhoneInput: false,
      phoneValidation: true,
      walletPhone: null
    };
  },
  computed: {
    price() {
      if (this.showPriceChanger) {
        return this.priceChanger;
      }
      return this.offerPrice;
    },
    isShowPayButton() {
      if (this.isBalanceUsed) {
        if (parseFloat(this.user.balance) >= parseFloat(this.price)) {
          return true;
        } else if (
          parseFloat(this.user.balance) < parseFloat(this.price) &&
          this.selectedPaymentMethod
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        if (this.selectedPaymentMethod) {
          return true;
        } else {
          return false;
        }
      }

      return false;
    },
    toPay() {
      let price = Number(this.price);

      if (this.isBalanceUsed) {
        if (parseFloat(this.user.balance) >= parseFloat(this.price)) {
          price = 0;
        } else if (
          parseFloat(this.user.balance) < parseFloat(this.price) &&
          this.selectedPaymentMethod
        ) {
          price = Number(
            Number(this.price) - Number(this.user.balance) + Number(this.selectedPaymentMethod.fee)
          );
        } else {
          price = Number(Number(this.price) - Number(this.user.balance));
        }
      } else if (this.selectedPaymentMethod) {
        price = Number(Number(this.price) + Number(this.selectedPaymentMethod.fee));
      } else {
        price = Number(this.price);
      }

      return price.toFixed(2);
    },
    ...mapState({
      user: state => state.auth.user
    })
  },
  watch: {
    show: function() {
      if (this.show == true) {
        let id = 'modalPayment'+ (this.isAds?'Ads':'');
        this.$refs[id].show();
      }
    },
    selectedPaymentMethod(val) {
      if (val !== null) {
        this.showFeeSpinner = true;
        this.paymentButtonDisabled = true;
      }
    },
    paymentForm(val) {
      if (val !== null && this.paymentFormSubmitScenario) {
        this.$nextTick(() => {
          document.getElementById("paymentForm").submit();
        });
      }
    }
  },
  methods: {
    phoneHandler() {
      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        this.getPaymentMethodForm();
      }, 2000);
    },
    modalHideHandler() {
      this.selectedPaymentMethod = null;
      this.isBalanceUsed = false;
      this.paymentForm = null;
      this.paymentFormSubmitScenario = false;
    },
    resetPayment() {
      this.isBalanceUsed = false;
      this.selectedPaymentMethod = null;
      this.showPhoneInput = false;
    },
    useBalance() {
      this.isBalanceUsed = true;
      this.selectedPaymentMethod = null;
      this.showPhoneInput = false;
      if (this.isBalanceUsed && parseFloat(this.user.balance) >= parseFloat(this.price))
      {
          this.showFeeSpinner = false;
          this.showBuySpinner = false;
          this.paymentButtonDisabled = false;
      }
    },
    selectPaymentMethod(key) {
      if (this.isBalanceUsed && parseFloat(this.user.balance) >= parseFloat(this.price)) {
        this.isBalanceUsed = false;
      }
      this.selectedPaymentMethod = this.paymentTypeList[key];
      this.selectedPaymentMethod.key = key;

      if (
        this.selectedPaymentMethod.type == "qiwi" ||
        this.selectedPaymentMethod.type == "mobile"
      ) {
        this.showPhoneInput = true;
        if (this.walletPhone == null) return;
      } else {
        this.showPhoneInput = false;
      }

      this.$yandexMetrika.reachGoal('buyer_interaction-with-payment-form');

      this.getPaymentMethodForm();
    },
    setForSameTypes(type, link, fee) {
      return this.paymentTypeList.forEach((item, index) => {
        if (item.type === type) {
          this.paymentTypeList[index].link = link;
          this.paymentTypeList[index].fee = fee;
        }
      });
    },
    getPaymentMethodForm() {
      //if(this.selectedPaymentMethod.link !== null){
      //  setTimeout( () => {
      //    this.showFeeSpinner = false;
      //    this.showBuySpinner = false;
      //    this.paymentButtonDisabled = false;
      //  }, 300);
      //  return;
      //}

      let sum = this.toPay - this.selectedPaymentMethod.fee;
      let url =
        "/transactions/payment-data?gateway=5&paymentType=" +
        this.selectedPaymentMethod.alias +
        "&sum=" +
        parseFloat(sum).toFixed(2) +
        (this.orderId?("&orderId=" +
        this.orderId):(''+this.isAds?'&isAds=true':''));
      if (this.showPhoneInput) {
        url += "&params[phone]=" + this.walletPhone;
      }

      axios
        .get(url)
        .then(response => {
          let amount = Number(
            (parseFloat(response.data.data.data.sum) - sum).toFixed(2)
          );
          this.selectedPaymentMethod.fee = amount;
          this.selectedPaymentMethod.link = response.data.data.data.url;
          this.setForSameTypes(
            this.selectedPaymentMethod.type,
            response.data.data.data.url,
            amount
          );
          this.showFeeSpinner = false;
          this.showBuySpinner = false;
          this.paymentButtonDisabled = false;
        })
        .catch(err => {
          if ((err.status = 422)) {
            let errorText = err.response.data.data
              ? err.response.data.data.error
              : null;
            this.$noty.error(
              errorText ? errorText : "Произошла ошибка! Обратитесь в поддержку"
            );
            if (
              errorText == "Не задан телефон плательщика" ||
              errorText == "Номер телефона обязателен для заполнения"
            ) {
              this.phoneValidation = false;
            }
          } else {
            this.$sentry.captureException(payment);
            this.$noty.error("Произошла ошибка! Обратитесь в поддержку");
            this.showBuySpinner = false;
          }
        });
    },
    promoTrigger: function() {
      this.promo = !this.promo;
    },
    payment() {
      this.showBuySpinner = true;
      if (this.toPay == 0) {
        if (this.isAds)
        {
          axios
          .post('/users/'+ this.user.jti +'/buy-ads-balance', { amount : parseFloat(this.price) })
          .then(response => {
            if (response.data.success) {
              this.hideModal();
              this.$noty.success("Рекламный баланс пополнен на сумму " + parseFloat(this.price) + "руб.");
              this.showBuySpinner = false;
            } else {
              this.showBuySpinner = false;
              if (Array.isArray(response.data.data))
              {
                response.data.data.forEach(item=>{
                  this.$noty.error("Не удалось пополнить рекламный баланс. " + item.message?item.message:'');
                })
              }
              else{
                this.$noty.error("Не удалось пополнить рекламный баланс. " + response.data.data.message?response.data.data.message:'')
              }

              return response.data.data;
            }
          })
          .catch(exception => {
            this.showBuySpinner = false;
            console.log(exception.response);
            if (Array.isArray(exception.response.data.data))
              {
                exception.response.data.data.forEach(item=>{
                  this.$noty.error("Не удалось пополнить рекламный баланс. " + (item.message?item.message:''));
                })
              }
              else{
                this.$noty.error("Не удалось пополнить рекламный баланс. " + (exception.response.data.data.message?exception.response.data.data.message:''))
              }
          });
        }
        else{
          axios
          .post("/orders/" + this.orderId + "/purchase")
          .then(response => {
            if (response.data.success) {
              this.showBuySpinner = false;
              this.hideModal();
              this.$store.commit("order/setOrderStatus", 2);
              this.$emit("payment-success", this.orderId);
            } else {
              this.showBuySpinner = false;
              return response.data.data;
            }
          })
          .catch(exception => {
            this.showBuySpinner = false;
            this.$noty.error('Ошибка. ' + errorResponse(exception.response.data.data));
            console.log(exception);
          });
        }
      } else {
        if (this.selectedPaymentMethod.link) {
          this.$yandexMetrika.reachGoal('buyer_payment-redirect');
          window.location = this.selectedPaymentMethod.link;
        }
      }
    },
    hideModal: function() {
      this.modalClose();
      let id = 'modalPayment'+ (this.isAds?'Ads':'');
      this.$refs[id].hide();
    },
    submitInternalForm() {
      let form = document.getElementById("internalForm");
      let formData = new FormData(form);

      var object = {};
      formData.forEach((value, key) => {
        if (!object.hasOwnProperty(key)) {
          object[key] = value;
          return;
        }
        if (!Array.isArray(object[key])) {
          object[key] = [object[key]];
        }
        object[key].push(value);
      });

      axios
        .post("/transactions/ik-gate-payment-data", object)
        .then(res => {
          if (res.data.data.data.resultCode != 0) {
            this.$noty.error(res.data.data.data.resultMsg);
          }
          this.paymentForm = this.generateHiddenForm(
            res.data.data.data.resultData
          );
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.internal-form {
  /deep/ form {
    display: block;
    float: left;
    width: 100%;
    border-top: 1px solid #eff1f4;
    padding-top: 20px;
    margin-top: 12px;
  }
  /deep/ .control-group {
    vertical-align: middle;
    display: inline-block;
  }
  /deep/ .control-label {
    color: #6e7279;
    width: 100%;
    display: block;
    margin-bottom: 10px;
    line-height: 1.4;
  }
}
.modalPaymentHeader {
  font-size: 20px;
  color: #2d303a;
}
.content {
  padding: 17px 32px 0;
}
.description {
  position: relative;
  display: block;
  margin-bottom: 20px;
  padding-left: 71px;
  font-size: 16px;
  line-height: 23px;
  font-weight: 500;
  max-width: 465px;
  &:before {
    position: absolute;
    left: 0;
    content: "";
    width: 51px;
    height: 50px;
    background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MSA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQ3LjkzNDYgMzUuNTUwNkM0OC4xMjI3IDM1LjA1OTIgNDcuODkyOSAzNC41MTU2IDQ3LjQwMTkgMzQuMzE2OUM0Ni45MTEgMzQuMTI4NyA0Ni4zNjc4IDM0LjM1ODcgNDYuMTY5MyAzNC44NTAxQzQ1LjQ0ODYgMzYuNjc5OCA0My42NTIgMzcuOTEzNiA0MS42ODgyIDM3LjkxMzZIMjEuODczQzIxLjYzMjcgMzcuOTEzNiAyMS4zOTI1IDM4LjAwNzcgMjEuMjE0OSAzOC4xNzVMMTIuMTY5MSA0Ni44NDI1VjM4Ljg1NDZDMTIuMTY5MSAzOC42MDM2IDEyLjA2NDYgMzguMzYzMiAxMS44ODcgMzguMTg1NEMxMS43MDk1IDM4LjAwNzcgMTEuNDY5MiAzNy45MDMxIDExLjIxODUgMzcuOTAzMUg2LjcwNjA0QzQuMDUyODcgMzcuOTAzMSAxLjg5MDY0IDM1LjczODggMS44OTA2NCAzMy4wODMyVjExLjcyMjhDMS44OTA2NCA5LjA2NzE1IDQuMDUyODcgNi45MDI4OCA2LjcwNjA0IDYuOTAyODhIMjguMTcxN0MyOC42OTM5IDYuOTAyODggMjkuMTIyMiA2LjQ3NDIxIDI5LjEyMjIgNS45NTE0NEMyOS4xMjIyIDUuNDI4NjcgMjguNjkzOSA1IDI4LjE3MTcgNUg2LjcwNjA0QzMuMDA4MzIgNSAwIDguMDExMTUgMCAxMS43MTI0VjMzLjA4MzJDMCAzNi43ODQ0IDMuMDA4MzIgMzkuNzk1NSA2LjcwNjA0IDM5Ljc5NTVIMTAuMjc4NFY0OS4wNTlDMTAuMjc4NCA0OS40MzU0IDEwLjUwODIgNDkuNzgwNCAxMC44NTI5IDQ5LjkyNjhDMTAuOTY3OCA0OS45NzkxIDExLjEwMzYgNTAgMTEuMjI5IDUwQzExLjQ2OTIgNTAgMTEuNzA5NSA0OS45MDU5IDExLjg4NyA0OS43Mzg2TDIyLjI1OTUgMzkuNzk1NUg0MS42OTg2QzQ0LjQyNDkgMzkuODA2IDQ2LjkzMTkgMzguMDkxMyA0Ny45MzQ2IDM1LjU1MDZaIiBmaWxsPSIjMkQzMDNBIi8+CjxwYXRoIGQ9Ik01MC45NDAyIDE2LjA1NjFDNTEuMjIyMyAxNC4yODM0IDUwLjQ5MDkgMTIuNDc5MiA0OS4wODA2IDExLjQ2MThDNDguMjc2MSAxMC44ODQ4IDQ3LjMzNTkgMTAuNTgwNyA0Ni4zNTM4IDEwLjU4MDdIMzkuNDI3M1Y1LjYwODY4QzM5LjQyNzMgMy40MDU5MSAzOC43Nzk2IDEuODExNTIgMzcuNTA1IDAuODc3OTY1QzM1LjQ4ODcgLTAuNjExNTI5IDMyLjczMDYgMC4yMzgxMTIgMzIuNjE1NyAwLjI2OTU4QzMyLjIxODcgMC4zOTU0NTMgMzEuOTU3NSAwLjc2MjU4MiAzMS45NTc1IDEuMTcxNjdWNi45MDkzN0MzMS45NTc1IDExLjMyNTQgMjYuODI3OSAxMi44MzU5IDI2LjYxOSAxMi44OTg4QzI2LjU5ODEgMTIuOTA5MyAyNi41NzcyIDEyLjkxOTggMjYuNTU2MyAxMi45MTk4QzI2LjI0MjkgMTIuNDM3MyAyNS42OTk2IDEyLjExMjEgMjUuMDcyOCAxMi4xMTIxSDE5Ljc2NTZDMTguNzk0IDEyLjExMjEgMTggMTIuOTA5MyAxOCAxMy44ODQ4VjI5LjM3NzdDMTggMzAuMzUzMiAxOC43OTQgMzEuMTUwNCAxOS43NjU2IDMxLjE1MDRIMjUuMDcyOEMyNS41NjM4IDMxLjE1MDQgMjYuMDAyNiAzMC45NTExIDI2LjMyNjUgMzAuNjI1OUMyNy4xNzI3IDMxLjQ3NTUgMjguMzQyOCAzMiAyOS42MzgyIDMySDQzLjYxNjdDNDYuNzgyMiAzMiA0OC43OTg1IDMwLjMzMjIgNDkuMTY0MSAyNy40MjY2TDUwLjk0MDIgMTYuMDU2MVpNMjQuOTQ3NCAyOS4yNTE4SDE5LjkwMTRWMTQuMDIxMkgyNC45NDc0VjI5LjI1MThaTTQ5LjA3MDEgMTUuNzYyNEw0Ny4yODM2IDI3LjE1MzlDNDcuMjgzNiAyNy4xNjQ0IDQ3LjI4MzYgMjcuMTc0OSA0Ny4yODM2IDI3LjE4NTRDNDcuMDQzNCAyOS4xMjU5IDQ1LjgxMDYgMzAuMTExOSA0My42MTY3IDMwLjExMTlIMjkuNjM4MkMyOC4wOTIgMzAuMTExOSAyNi44Mzg0IDI4Ljg1MzIgMjYuODM4NCAyNy4zMDA3VjE0Ljc2NTlDMjYuOTMyNCAxNC43NjU5IDI3LjAyNjQgMTQuNzY1OSAyNy4xMjA0IDE0LjczNDVDMjcuMzkyMSAxNC42NjEgMzMuODQ4NSAxMi43ODM0IDMzLjg0ODUgNi45MDkzN1YxLjk0Nzg4QzM0LjUzOCAxLjg1MzQ4IDM1LjYwMzYgMS44MzI1IDM2LjM5NzYgMi40MDk0MkMzNy4xNjAzIDIuOTc1ODQgMzcuNTM2NCA0LjA0NTc2IDM3LjUzNjQgNS42MDg2OFYxMS41MzUyQzM3LjUzNjQgMTIuMDU5NyAzNy45NjQ3IDEyLjQ4OTcgMzguNDg3MSAxMi40ODk3SDQ2LjM2NDNDNDYuOTQ5MyAxMi40ODk3IDQ3LjUxMzUgMTIuNjY4IDQ3Ljk4MzYgMTMuMDE0MkM0OC44MDg5IDEzLjYxMjEgNDkuMjM3MyAxNC42OTI1IDQ5LjA3MDEgMTUuNzYyNFoiIGZpbGw9IiM0NkJGNEEiLz4KPC9zdmc+Cg==");
  }
}
.textarea {
  width: 100%;
  height: 161px;
  padding: 10px 14px;
  border: 1px solid #dadada;
  border-radius: 4px;
  color: #6e7279;
  resize: none;
}
.modalPaymentFooter {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .btn {
    margin-left: auto;
    min-width: 160px;
    font-weight: 500;
  }
}
.icon-back {
  margin-right: 16px;
  fill: #a8aaaf;
  cursor: pointer;
  transition: $link-transition;
  &:hover {
    fill: #2d303a;
  }
}
.modalPaymentHeader {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.balance {
  margin-left: auto;
  font-size: 20px;
  color: #2d303a;
  span {
    font-size: 14px;
    color: #2d303a;
  }
}
.price-changer-wrapper {
  color: #6e7279;
  font-size: 12px;
  line-height: 12px;
  margin-top: 22px;
}
.item {
  position: relative;
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #eff1f4;

  span {
    color: #6e7279;
    font-size: 14px;
  }
  strong {
    font-weight: 400;
    span {
      margin-left: 10px;
      font-size: 14px;
      color: #a8aaaf;
    }
  }
}
.item-title {
  padding-right: 170px;
}
.item-count {
  position: absolute;
  top: 0;
  right: 0;
  text-align: right;
  width: 150px;
}

.payment-items {
  margin-top: 20px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  color: #6e7279;
  > span {
    width: 100%;
    display: block;
    margin-bottom: 10px;
    line-height: 1.4;
  }
}

.payment-item {
  margin-right: 12px;
  margin-bottom: 12px;
  font-size: 12px;
  cursor: pointer;
  &:hover {
    .payment-item-content {
      border-color: $green;
    }
  }
  strong {
    display: block;
    color: $green;
    line-height: 12px;
  }
  input {
    display: none;
    .selected + .payment-item-content {
      border: 1px solid $blue;
      box-shadow: 0 0 0 1px #098aff;
      background: rgba(9, 138, 255, 0.05);
    }
  }
}
#price-changer{
  width: 240px;
}
.selected {
  border: 1px solid $blue;
  box-shadow: 0 0 0 1px #098aff;
  background: rgba(9, 138, 255, 0.05);
}

.payment-item-content {
  width: 72px;
  height: 40px;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid #dadada;
  transition: $link-transition;
}
.promo {
  margin-top: 5px;
  a {
    position: relative;
    color: #a8aaaf;
    cursor: pointer;
    &:after {
      position: absolute;
      content: "";
      width: 100%;
      top: 100%;
      left: 0;
      right: 0;
      height: 1px;
      background: #a8aaaf;
      transition: $link-transition;
    }
    &:hover {
      color: $green;
      &:after {
        opacity: 0;
      }
    }
  }
}
.promoForm {
  position: relative;
  width: 240px;
}
.promoInput {
  border-radius: 4px;
  border: 1px solid #dadada;
}
.icon-ok {
  fill: #ffffff;
}
.promo {
  display: flex;
  align-items: flex-end;
  height: 40px;
}
.promo-submit {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 100%;
  padding: 0;
}
.icon-close {
  fill: #a8aaaf;
  display: block;
  cursor: pointer;
  transition: $link-transition;
  &:hover {
    fill: $red;
  }
}
.promoFormGroup {
  margin: 0;
}
.promoFormClose {
  position: absolute;
  left: 100%;
  top: 50%;
  margin-left: 16px;
  margin-top: -5px;
}

.total-price,
.total-commission,
.total-payment {
  font-size: 20px;
  color: #2D303A;
  span {
    display: block;
    color: #6e7279;
    font-size: 14px;
  }
}
.total-commission {
  position: relative;
  padding-left: 61px;
  &:before {
    position: absolute;
    left: 25px;
    bottom: 1px;
    content: "+";
    font-size: 20px;
    font-weight: 500;
    color: #a8aaaf;
  }
  span {
    &:after {
      margin-left: 5px;
      margin-top: -8px;
      display: inline-block;
      vertical-align: middle;
      width: 16px;
      height: 20px;
      background-size: 100%;
      content: "";
    }
  }
  img {
    height: 16px;
  }
}
.total-payment {
  position: relative;
  padding-left: 63px;
  &:before {
    position: absolute;
    left: 25px;
    bottom: 1px;
    content: "=";
    font-size: 20px;
    font-weight: 500;
    color: #a8aaaf;
  }
}
.warring {
  display: block;
  color: $red;
}
.well {
  background: #eff1f4;
  border-radius: 4px;
  padding: 0 16px;
}
.plus-icon {
  display: block;
  margin: -12px 14px 0 2px;
}
</style>
